/**
 * Accessible Smooth Scroll with jQuery
 *
 * This script enables smooth page scrolling to anchors within the same page. 
 * It respects user preferences for reduced motion and handles various path scenarios 
 * to ensure correct link targeting. 
 *
 * Modifications:
 * The code is based on the "Smooth Scrolling and Accessibility" article and includes
 * updates to reflect modern browser capabilities. Notably, focus management has been
 * removed from this script. Most browsers now support the Sequential Focus Navigation 
 * Starting Point feature natively, making additional focus management redundant. 
 *
 * Key Features:
 * - Filters paths to match directory or default index pages for improved link handling.
 * - Respects `prefers-reduced-motion` settings, applying smooth scrolling only when appropriate.
 * - Skips specific links based on class filters (e.g., `.no-scroll`).
 * - Avoids updating the URL hash for specific link IDs (e.g., `homeHeroJumpLink` - used in the Graduate theme).
 *
 * Sources:
 * - Smooth Scrolling and Accessibility: https://css-tricks.com/smooth-scrolling-accessibility/
 * - Scroll Handling Reference: Update 3 on http://www.learningjquery.com/2007/10/improved-animated-scrolling-script-for-same-page-links
 */
$(function() {
    
    // Function to normalize pathnames by removing leading slashes, default filenames, and trailing slashes.
    // This helps in correctly matching links within directories and default index pages.
    const filterPath = (string) => string
        .replace(/^\//, '')
        .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
        .replace(/\/$/, '');

    // Current page pathname filtered for smooth scrolling compatibility.
    const locationPath = filterPath(location.pathname);
    
    // Check the user's motion preference settings.
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');
    
    // Add smooth scrolling only if the user has not indicated a preference for reduced motion.
    if (mediaQuery.matches) {
        $('a[href*="#"]').each(function() {
            const $this = $(this);
            const href = $this.attr('href');
            const linkPath = filterPath(this.pathname);
            const linkId = $this.attr('id');
            
            // Early return if link does not point to the current page
            if (linkPath !== locationPath) {
                return; // Skip processing this link
            }
            
            // Now that we're sure the link is on the current page, set the target
            const targetSelector = href && href.indexOf('#') > -1 ? href.split('#')[1] : '';
            const target = targetSelector ? $('#' + targetSelector) : $();
            
            if (
                target.length &&
                !(
                    $this.is('[data-toggle="collapse"]') ||
                    $this.hasClass('no-scroll') ||
                    $this.hasClass('tabs-link') ||
                    $this.hasClass('ui-tabs-anchor') ||
                    $this.hasClass('site-sr-jump-link') ||
                    $this.hasClass('cel-sr-jump-link')
                ) &&
                (location.hostname === this.hostname || !this.hostname)
            ) {
                $this.on('click', function(event) {
                    event.preventDefault();
                    
                    // Animate scroll to the target element with a smooth effect.
                    $('html, body').animate({ scrollTop: target.offset().top }, 600, function() {
                        // Update the URL hash after scrolling, unless the link has a specific ID.
                        if (linkId !== 'homeHeroJumpLink') {
                            location.hash = href;
                        }
                    });
                });
            }
        });
    }
});